import React, { useEffect, useState, useMemo } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { FormatDateTime } from "../../../../../../utils/functions/ResourceFunctions";
import {
  useApproveDeclineKRAMutation,
  useDeleteKRAMutation,
  useGetKRAForObjectivesQuery,
  useGetKRAQuery,
  useGetSingleAppraisalObjectiveQuery,
  useGetSingleKeyResultAreaQuery,
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import {
  ActionButtons,
  CTAButtons,
} from "../../../../../global/components/Buttons/buttons";
import { FormTemplate } from "../../../../Components/Forms/InputTemplate";
import PageLayout from "../../../../Components/Layout/PageLayout";
import ApproveModal from "../Modals/ApproveModal";
import { AppraisalDeclineModal } from "../Modals/DeclineModal";
import {
  appraisalPeriod,
  appraisalPeriodFormatter,
  crossReviewTypeFormatter,
  MeasurementType,
  MeasurementTypeFormatter,
} from "../Modals/data";
import { getMyPermissions } from "../../../../../../utils/functions/GetMyPermissions";
import { TableActions } from "../../../../Components/Misc/Actions";
import { AppModalTemplate } from "../../../../Components/Modals/Modals";
import ObjectiveKraViewModal from "../Modals/ObjectiveKraViewModal";
import Table from "../../../../Components/Table/Table";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../../Components/Search/Search";
import { useSearchFilter } from "../../../../../../utils/functions/useDate";
import { AppraisalPeriodEnum, FilterByStatus, KRATaskType } from "../status";
import { DEFINED_PERMISSIONS } from "../../../../../../utils/const";
import DeleteItemModal from "../../../../Components/Modals/DeleteItemModal";
import { EditKRAModal } from "../Modals/EditKRAModal";
import { getStatusText } from "../../../Finance/CostCenter/Class";
import Pagination from "../../../../Components/Pagination/Pagination";
const renderBooleanBadge = (value) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "12px",
      fontWeight: "500",
      backgroundColor: value ? "#dcfce7" : "#f3f4f6",
      color: value ? "#166534" : "#374151",
      border: `1px solid ${value ? "#bbf7d0" : "#d1d5db"}`,
    }}
  >
    {value ? "Yes" : "No"}
  </span>
);

export const ViewKeyResultArea = () => {
  const { id } = useParams();
  const { data } = useGetSingleAppraisalObjectiveQuery(id);
  const navigation = useNavigate();
  const [approveDecline, { isLoading }] = useApproveDeclineKRAMutation();
  const [openApproveModal, setOpenApproveModal] = React.useState(false);
  const [openDeclineModal, setOpenDeclineModal] = React.useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [kraId, setKraId] = useState(null);

  const [comment, setComment] = React.useState("");
  const [matchedPermissionHr, setMatchedPermissionHr] = useState("");
  const [matchedPermissionJAO, setMatchedPermissionJAO] = useState("");
  const [soaPerm, setSoaPerm] = useState(false);
  useEffect(() => {
    const userPerm = JSON.parse(localStorage.getItem("x-u-perm"));
    const hrPerm = [
      DEFINED_PERMISSIONS.SeniorHRManager,
      DEFINED_PERMISSIONS.PrimaryHRManager,
      DEFINED_PERMISSIONS.SeniorAppraisalOfficer,
    ];
    const definedSoaPerm = DEFINED_PERMISSIONS.SeniorAppraisalOfficer;
    const hasSoaPermission = userPerm.includes(definedSoaPerm);
    setSoaPerm(hasSoaPermission);
    if (userPerm && userPerm.some((perm) => hrPerm.includes(perm))) {
      const matchedPerm = userPerm.find((perm) => hrPerm.includes(perm));
      setMatchedPermissionHr(matchedPerm);
    } else {
      setMatchedPermissionHr("");
    }
  }, []);
  useEffect(() => {
    const userPerm = JSON.parse(localStorage.getItem("x-u-perm"));
    const JOA = [DEFINED_PERMISSIONS.JuniorAppraisalOfficer];
    if (userPerm && userPerm.some((perm) => JOA.includes(perm))) {
      const matchedPerm = userPerm.find((perm) => JOA.includes(perm));
      setMatchedPermissionJAO(matchedPerm);
    } else {
      setMatchedPermissionJAO("");
    }
  }, []);
  const {
    searchText,
    filter,
    setSearchText,
    setFilter,
    pageSize,
    currentPage,
    setPageSize,
    setCurrentPage,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [period, setPeriod] = useState();
  const [openDelete, setOpenDelete] = useState(false);
  const [onDelete] = useDeleteKRAMutation();
  const [selectedId, setSelectedId] = useState(null);
  const [taskType, setTaskType] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  const declineVariable = 1;
  const approveVaiable = 0;
  const handleComment = (e) => {
    setComment(e.target.value);
  };
  const declineAction = async (type, isBatch = false) => {
    if (!comment && type === 1) {
      toast.error("Please enter a comment");
      return;
    }
    try {
      let requestPayload;
      if (isBatch) {
        // For batch operations
        if (type === 0) {
          // Approve multiple items
          requestPayload = {
            kraIds: selectedItems,
            comment,
            approvalType: type,
          };
        } else {
          // Decline single item only - strict validation
          if (selectedItems.length === 0) {
            toast.error("Please select exactly one KRA to decline");
            return;
          }
          if (selectedItems.length > 1) {
            toast.error(
              "You can only decline one KRA at a time. Please select only one item."
            );
            return;
          }
          requestPayload = {
            kraIds: selectedItems,
            comment,
            approvalType: type,
          };
        }
      } else {
        // For single objective approval/decline (existing functionality)
        requestPayload = {
          kraId: parseInt(id),
          comment,
          approvalType: type,
        };
      }

      const response = await approveDecline(requestPayload).unwrap();
      if (response?.successful) {
        setOpenDeclineModal(false);
        setOpenApproveModal(false);
        if (isBatch) {
          setSelectedItems([]);
          setSelectAll(false);
        }
        toast.success(response?.statusMessage || "KRAs processed successfully");
        if (!isBatch) {
          navigation("/dashboard/hr/HR-Appraisal-Setup/key-result-area");
        }
      }
    } catch (error) {
      toast.error(error.data?.statusMessage ?? "Error processing KRAs");
    }
  };

  const handleBatchApproval = () => {
    if (selectedItems.length === 0) {
      toast.error("Please select at least one KRA to approve");
      return;
    }
    setOpenApproveModal(true);
  };

  const handleBatchDecline = () => {
    if (selectedItems.length === 0) {
      toast.error("Please select exactly one KRA to decline");
      return;
    }
    if (selectedItems.length > 1) {
      toast.error(
        "You can only decline one KRA at a time. Please select only one item."
      );
      return;
    }
    setOpenDeclineModal(true);
  };
  const handleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const handleDeclineModal = () => setOpenDeclineModal(!openDeclineModal);
  const [userPermissions, setUserPermissions] = useState([]);
  useEffect(() => {
    setUserPermissions(getMyPermissions());
  }, []);
  const { data: keyResultArea } = useGetKRAQuery({
    ObjectiveId: data?.responseObject?.id,
    Search: searchText,
    PageSize: pageSize,
    PageNumber: currentPage,
    AppraisalPeriod: period,
    ApprovalStatus: filter,
    StartDate: startDate,
    EndDate: endDate,
    Type: taskType,
  });
  const handleView = (id) => {
    if (id) {
      setOpen(!open);
      setKraId(id);
    } else {
      setOpen(false);
      setKraId(null);
    }
  };
  const handleOpenDeleteModal = (id) => {
    if (id) {
      setSelectedId(id);
      setOpenDelete(true);
    }
  };
  const handleModal = () => {
    setOpenModal(!openModal);
  };
  const handleEdit = (id) => {
    if (id) {
      setSelectedId(id);
      handleModal();
    }
  };
  const handleCloseDelete = () => {
    setSelectedId(null);
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    try {
      const response = await onDelete({
        id: Number.parseInt(selectedId),
      }).unwrap();
      if (response?.successful) {
        handleCloseDelete();
        toast.success(response?.statusMessage);
      } else {
        toast.error(response?.data?.title);
      }
    } catch (error) {
      toast.error(error.data.statusMessage ?? "Error deleting Key Result Area");
    }
  };
  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    if (checked) {
      const allIds = keyResultArea?.result?.map((item) => item.id) || [];
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelection = (item, checked) => {
    if (checked) {
      setSelectedItems((prev) => [...prev, item.id]);
    } else {
      setSelectedItems((prev) => prev.filter((id) => id !== item.id));
      setSelectAll(false);
    }
  };

  const isItemSelected = (itemId) => {
    return selectedItems.includes(itemId);
  };

  useEffect(() => {
    if (
      keyResultArea?.result?.length > 0 &&
      selectedItems.length === keyResultArea.result.length
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedItems, keyResultArea?.result]);

  const months = [
    { label: "January" },
    { label: "February" },
    { label: "March" },
    { label: "April" },
    { label: "May" },
    { label: "June" },
    { label: "July" },
    { label: "August" },
    { label: "September" },
    { label: "October" },
    { label: "November" },
    { label: "December" },
  ];

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortedData = useMemo(() => {
    if (!keyResultArea?.result) return [];
    return [...keyResultArea.result].sort((a, b) => {
      if (!sortColumn) return 0;
      let aValue = a[sortColumn];
      let bValue = b[sortColumn];

      if (sortColumn === "createdDate") {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      } else if (sortColumn === "weight") {
        aValue = parseFloat(aValue) || 0;
        bValue = parseFloat(bValue) || 0;
      } else if (sortColumn === "approvalStatus") {
        aValue = typeof aValue === "number" ? getStatusText(aValue) : aValue;
        bValue = typeof bValue === "number" ? getStatusText(bValue) : bValue;
      } else if (sortColumn === "type") {
        aValue = aValue === 1 ? "Core" : "Non-Core";
        bValue = bValue === 1 ? "Core" : "Non-Core";
      } else if (sortColumn === "measurementType") {
        aValue = MeasurementType[aValue]?.name || "";
        bValue = MeasurementType[bValue]?.name || "";
      } else if (sortColumn === "appraisalPeriod") {
        aValue = appraisalPeriod[aValue - 1]?.name || "";
        bValue = appraisalPeriod[bValue - 1]?.name || "";
      } else if (sortColumn === "designation") {
        aValue = aValue?.designationName || "";
        bValue = bValue?.designationName || "";
      } else {
        aValue = String(aValue || "").toLowerCase();
        bValue = String(bValue || "").toLowerCase();
      }

      if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  }, [keyResultArea?.result, sortColumn, sortDirection]);
  return (
    <PageLayout
      title={"Objectives Details"}
      hasBack={true}
      backURL={"/dashboard/hr/HR-Appraisal-Setup/key-result-area"}
    >
      <div className={DashboardStyle.app_view_controls}></div>
      <FormProvider>
        <FormTemplate className={DashboardStyle.view_app_components}>
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Process <br /> Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(32.3%, 1fr))",
                  gap: "10px",
                }}
              >
                <div>
                  <p>Title:</p>
                  <h4>{data?.responseObject?.title}</h4>
                </div>
                <div>
                  <p>Year:</p>
                  <h4>{data?.responseObject?.appraisalPeriod?.year}</h4>
                </div>
                <div>
                  <p>Description:</p>
                  <h4>{data?.responseObject?.description}</h4>
                </div>
                <div>
                  <p>Weight (%):</p>
                  <h4>{data?.responseObject?.weight}%</h4>
                </div>
                <div>
                  <p>Objective Type:</p>
                  <h4>{data?.responseObject?.objectiveType}</h4>
                </div>
                <div>
                  <p>Department:</p>
                  <h4>{data?.responseObject?.departmentName}</h4>
                </div>
                <div>
                  <p>Appraisal Period:</p>
                  <h4>
                    Start Month{" "}
                    {
                      months[
                        data?.responseObject?.appraisalPeriod?.startMonth ?? 0
                      ]?.label
                    }
                    {"; "}
                    End Month{" "}
                    {
                      months[
                        data?.responseObject?.appraisalPeriod?.endMonth ?? 0
                      ]?.label
                    }
                    {"; "}
                    Year {data?.responseObject?.appraisalPeriod?.year}
                  </h4>
                </div>
                <div>
                  <p>Approval Status:</p>
                  <h4>
                    {typeof data?.responseObject?.approvalStatus === "number"
                      ? getStatusText(data?.responseObject?.approvalStatus)
                      : data?.responseObject?.approvalStatus}
                  </h4>
                </div>
                <div>
                  <p>Created Date:</p>
                  <h4>
                    {FormatDateTime(
                      data?.responseObject?.createdDate,
                      "DD/MM/YYYY"
                    )}
                  </h4>
                </div>
                <div>
                  <p>Job Role:</p>
                  <div>
                    <h4>
                      {" "}
                      {data?.responseObject?.designation?.designationName}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </FormTemplate>
      </FormProvider>
      <form className={DashboardStyle.dashboard_filter}>
        <SearchFilter
          value={searchText}
          text={(searchText) => setSearchText(searchText)}
        />
        <CalendarFilter2
          name="Select Date Range"
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          normalDate
        />
        <ProDropFilter
          filter={filter}
          setFilter={setFilter}
          name={"Status"}
          filterBy={FilterByStatus}
        />
        <ProDropFilter
          filter={period}
          setFilter={setPeriod}
          name={"Appraisal Period"}
          filterBy={AppraisalPeriodEnum}
        />
        <ProDropFilter
          filter={taskType}
          setFilter={setTaskType}
          name={"KRA Task Type"}
          filterBy={KRATaskType}
        />
      </form>
      <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
        <CTAButtons
          onClick={handleBatchApproval}
          disabled={selectedItems.length === 0}
        >
          Approve Selected KRAs ({selectedItems.length})
        </CTAButtons>
        <CTAButtons
          onClick={handleBatchDecline}
          disabled={selectedItems.length !== 1}
          className={DashboardStyle?.button_cage_weight}
          style={{
            backgroundColor: selectedItems.length !== 1 ? "#ccc" : "#dc3545",
            cursor: selectedItems.length !== 1 ? "not-allowed" : "pointer",
          }}
        >
          {selectedItems.length === 0
            ? "Decline KRA (Select 1 item)"
            : selectedItems.length === 1
            ? "Decline Selected KRA (1)"
            : `Decline KRA (${selectedItems.length} selected - Select only 1)`}
        </CTAButtons>
      </div>
      <div className="desktop-table-view mt-5" style={{ display: "block" }}>
        <div
          className={DashboardStyle.dashboard_table_holder}
          style={{ overflowX: "auto" }}
        >
          <Table style={{ minWidth: "1200px", width: "100%" }}>
            <thead>
              <tr>
                <th style={{ minWidth: "60px", padding: "12px 8px" }}>S/N</th>
                <th>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    className="sr-only"
                  />
                  <div
                    className={`w-4 h-4 rounded border-2 flex items-center justify-center cursor-pointer ${
                      selectAll
                        ? "bg-[#18BB0C] border-[#18BB0C]"
                        : "bg-white border-gray-300 hover:border-gray-400"
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleSelectAll(!selectAll);
                    }}
                  >
                    {selectAll && (
                      <svg
                        className="w-3 h-3 text-white"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    )}
                  </div>
                </th>
                <th
                  style={{
                    minWidth: "200px",
                    padding: "12px 8px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("title")}
                >
                  Title
                  {sortColumn === "title" &&
                    (sortDirection === "asc" ? <FaSortUp /> : <FaSortDown />)}
                  {sortColumn !== "title" && <FaSort />}
                </th>
                <th
                  style={{
                    minWidth: "200px",
                    padding: "12px 8px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("type")}
                >
                  Type
                  {sortColumn === "type" &&
                    (sortDirection === "asc" ? <FaSortUp /> : <FaSortDown />)}
                  {sortColumn !== "type" && <FaSort />}
                </th>
                <th
                  style={{
                    minWidth: "200px",
                    padding: "12px 8px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("measurementType")}
                >
                  Measurement
                  {sortColumn === "measurementType" &&
                    (sortDirection === "asc" ? <FaSortUp /> : <FaSortDown />)}
                  {sortColumn !== "measurementType" && <FaSort />}
                </th>
                <th
                  style={{
                    minWidth: "200px",
                    padding: "12px 8px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("createdDate")}
                >
                  Date Created
                  {sortColumn === "createdDate" &&
                    (sortDirection === "asc" ? <FaSortUp /> : <FaSortDown />)}
                  {sortColumn !== "createdDate" && <FaSort />}
                </th>
                <th
                  style={{
                    minWidth: "200px",
                    padding: "12px 8px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("appraisalPeriod")}
                >
                  Period
                  {sortColumn === "appraisalPeriod" &&
                    (sortDirection === "asc" ? <FaSortUp /> : <FaSortDown />)}
                  {sortColumn !== "appraisalPeriod" && <FaSort />}
                </th>
                <th
                  style={{
                    minWidth: "150px",
                    padding: "12px 8px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("designation")}
                >
                  Job Role
                  {sortColumn === "designation" &&
                    (sortDirection === "asc" ? <FaSortUp /> : <FaSortDown />)}
                  {sortColumn !== "designation" && <FaSort />}
                </th>
                <th
                  style={{
                    minWidth: "100px",
                    padding: "12px 8px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("weight")}
                >
                  Weight
                  {sortColumn === "weight" &&
                    (sortDirection === "asc" ? <FaSortUp /> : <FaSortDown />)}
                  {sortColumn !== "weight" && <FaSort />}
                </th>
                <th
                  style={{
                    minWidth: "120px",
                    padding: "12px 8px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("approvalStatus")}
                >
                  Status
                  {sortColumn === "approvalStatus" &&
                    (sortDirection === "asc" ? <FaSortUp /> : <FaSortDown />)}
                  {sortColumn !== "approvalStatus" && <FaSort />}
                </th>
                <th style={{ minWidth: "120px", padding: "12px 8px" }}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {(() => {
                if (isLoading) {
                  return (
                    <tr>
                      <td
                        colSpan={11}
                        className="text-center"
                        style={{ padding: "40px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                          }}
                        >
                          <div
                            style={{
                              width: "20px",
                              height: "20px",
                              border: "2px solid #e5e7eb",
                              borderTop: "2px solid #3b82f6",
                              borderRadius: "50%",
                              animation: "spin 1s linear infinite",
                            }}
                          ></div>
                          Loading...
                        </div>
                      </td>
                    </tr>
                  );
                } else if (sortedData && sortedData?.length > 0) {
                  return sortedData?.map((item, index) => (
                    <tr
                      key={item.id}
                      style={{ borderBottom: "1px solid #e5e7eb" }}
                    >
                      <td style={{ padding: "12px 8px" }}>{index + 1}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={isItemSelected(item.id)}
                          onChange={(e) =>
                            handleSelection(item, e.target.checked)
                          }
                          className="sr-only"
                        />
                        <div
                          className={`w-4 h-4 rounded border-2 flex items-center justify-center cursor-pointer ${
                            isItemSelected(item.id)
                              ? "bg-[#18BB0C] border-[#18BB0C]"
                              : "bg-white border-gray-300 hover:border-gray-400"
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            handleSelection(item, !isItemSelected(item.id));
                          }}
                        >
                          {isItemSelected(item.id) && (
                            <svg
                              className="w-3 h-3 text-white"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clipRule="evenodd"
                              />
                            </svg>
                          )}
                        </div>
                      </td>
                      <td style={{ padding: "12px 8px" }}>
                        <div
                          style={{
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={item?.title}
                        >
                          {item?.title}
                        </div>
                      </td>
                      <td style={{ padding: "12px 8px" }}>
                        {item?.type === 1 ? "Core" : "Non-Core"}
                      </td>
                      <td style={{ padding: "12px 8px" }}>
                        {item?.measurementType &&
                          MeasurementType[item?.measurementType]?.name}
                      </td>
                      <td style={{ padding: "12px 8px" }}>
                        {FormatDateTime(item?.createdDate, "DD/MM/YYYY")}
                      </td>
                      <td style={{ padding: "12px 8px" }}>
                        {item?.appraisalPeriod &&
                          appraisalPeriod[item?.appraisalPeriod - 1]?.name}
                      </td>
                      <td style={{ padding: "12px 8px" }}>
                        {item?.designation?.designationName || "-"}
                      </td>
                      <td style={{ padding: "12px 8px" }}>
                        {item?.weight !== null ? item.weight : "-"}
                      </td>
                      <td style={{ padding: "12px 8px" }}>
                        {typeof item?.approvalStatus === "number"
                          ? getStatusText(item?.approvalStatus)
                          : item?.approvalStatus}
                      </td>
                      <td style={{ padding: "12px 8px" }}>
                        <TableActions
                          hasChildren={true}
                          // url={matchedPermissionHr  ? `${item.id}/view` : ""}
                        >
                          {[
                            {
                              name:
                                (!soaPerm ||
                                  (matchedPermissionHr &&
                                    matchedPermissionJAO)) &&
                                item?.approvalStatus !== 0 &&
                                "Edit",
                              action: () =>
                                (!soaPerm ||
                                  (matchedPermissionHr &&
                                    matchedPermissionJAO)) &&
                                item?.approvalStatus !== 0 &&
                                handleEdit(item.id),
                            },
                            {
                              name: matchedPermissionHr ? "View" : null,
                              action: () =>
                                matchedPermissionHr
                                  ? handleView(item.id)
                                  : null,
                            },
                            {
                              name:
                                item?.approvalStatus !== 0 ? "Delete" : null,
                              action: () =>
                                item?.approvalStatus !== 0
                                  ? handleOpenDeleteModal(item.id)
                                  : null,
                            },
                          ]}
                        </TableActions>
                      </td>
                    </tr>
                  ));
                } else {
                  return (
                    <tr>
                      <td
                        colSpan={11}
                        className="text-center"
                        style={{ padding: "40px" }}
                      >
                        No KRA Found
                      </td>
                    </tr>
                  );
                }
              })()}
            </tbody>
          </Table>
        </div>

        <Pagination
          last_page={keyResultArea?.totalPages}
          present_page={keyResultArea?.currentPage}
          totalRows={keyResultArea?.totalRows}
          pageSize={pageSize}
          setPageSize={(page) => setPageSize(page)}
          click={(page) => setCurrentPage(page)}
        />
      </div>
      {open && (
        <AppModalTemplate
          width={"600px"}
          isOpen={open}
          setIsOpen={() => handleView(null)}
        >
          <ObjectiveKraViewModal
            isOpen={open}
            setIsOpen={() => handleView(null)}
            id={kraId}
          />
        </AppModalTemplate>
      )}
      {openModal && selectedId && (
        <AppModalTemplate
          width={"600px"}
          isOpen={openModal}
          setIsOpen={handleModal}
        >
          <EditKRAModal
            isOpen={openModal}
            setIsOpen={setOpenModal}
            onValidate={handleModal}
            id={selectedId}
          />
        </AppModalTemplate>
      )}

      <DeleteItemModal
        isOpen={openDelete}
        handleClose={handleCloseDelete}
        handleDelete={handleDelete}
        headText={"Delete Key Result Area"}
        infoText={"Are you sure you want to Delete this Key Result Area?"}
      />
      {openDeclineModal && (
        <AppraisalDeclineModal
          openModal={openDeclineModal}
          closeModal={handleDeclineModal}
          handleComment={handleComment}
          handleDelete={() =>
            declineAction(declineVariable, selectedItems.length > 0)
          }
          isLoading={isLoading}
          // disabled={!comment}
          headText={
            selectedItems.length > 0
              ? `Decline Selected KRA (${selectedItems.length})`
              : "Decline Key Result Area"
          }
        />
      )}
      <ApproveModal
        isOpen={openApproveModal}
        handleClose={handleApproveModal}
        handleDelete={() =>
          declineAction(approveVaiable, selectedItems.length > 0)
        }
        handleComment={handleComment}
        isLoading={isLoading}
        headText={
          selectedItems.length > 0
            ? `Approve Selected KRAs (${selectedItems.length})`
            : "Approve Key Result Area"
        }
      />
    </PageLayout>
  );
};
